import { render, staticRenderFns } from "./GvdResourceList.vue?vue&type=template&id=63e32141"
import script from "./GvdResourceList.vue?vue&type=script&lang=ts"
export * from "./GvdResourceList.vue?vue&type=script&lang=ts"
import style0 from "./GvdResourceList.vue?vue&type=style&index=0&id=63e32141&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports